import Vue from 'vue';
import Vuex from 'vuex';
import app from "./modules/app";
import user from "./modules/user";
import tagsView from "./modules/tagsView";
import permission from "./modules/permission";
import settings from "./modules/settings";
import getters from "./getters";
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app,
    user: user,
    tagsView: tagsView,
    permission: permission,
    settings: settings
  },
  getters: getters
});
export default store;